export interface Option {
  disabled: boolean;
  hidden: boolean;
  innerHTML: string;
  label: string;
  selected: boolean;
  value: string;
}
